import classNames from 'classnames';
import React, { FC } from 'react';

import { Incomplete, InProgress, Success, Warning } from 'src/Icons';
import { StatusLabelClassNames, StatusLabelStatus } from 'src/types';

export interface StatusIconProps {
  className?: string;
  /** The icon's accessible name. Without one the icon is decorative. */
  label?: string;
  status: `${StatusLabelStatus}`;
}

/**
 * `SvgIcon` stays `aria-hidden` until it gets `titleAccess`, and each icon in
 * `src/Icons` hardcodes an `aria-label` that would beat the title, so a named
 * icon sets both. There is no default name: this package has no i18n layer,
 * and the chip's text usually carries the localized state already.
 */
const accessibleName = (label?: string) => (label ? { 'aria-label': label, titleAccess: label } : {});

export const StatusIcon: FC<StatusIconProps> = ({ className, label, status }) => {
  switch (status) {
    case StatusLabelStatus.INCOMPLETE:
      return (
        <Incomplete {...accessibleName(label)} className={classNames(className, StatusLabelClassNames.INCOMPLETE)} />
      );

    case StatusLabelStatus.IN_PROGRESS:
      return (
        <InProgress {...accessibleName(label)} className={classNames(className, StatusLabelClassNames.IN_PROGRESS)} />
      );

    case StatusLabelStatus.SUCCESS:
      return <Success {...accessibleName(label)} className={classNames(className, StatusLabelClassNames.SUCCESS)} />;

    case StatusLabelStatus.WARNING:
      return <Warning {...accessibleName(label)} className={classNames(className, StatusLabelClassNames.WARNING)} />;

    default:
      return null;
  }
};
